import React, { useState } from 'react'
import { Steps } from 'primereact/steps';
import { useTranslation } from 'react-i18next';

const StepsIncident = ({ stepsactiveIndex, setStepsActiveIndex }) => {
    const { t } = useTranslation();
    const StepItems = [
        {
            label: t('Reporter and Incident Details')
        },
        {
            label: t('Profile of The Victim')
        },
        {
            label: t('Papetrator Details and File Upload')
        }
    ];



  return (
      <div>
          <Steps
              
          model={StepItems}
          activeIndex={stepsactiveIndex}
          onSelect={(e) => setStepsActiveIndex(e.index)}
          readOnly={false}
            className='newIncidentSteps'
            identity="nextSteps"
          />
      
      </div>
  )
}

export default StepsIncident